import { Outlet, RouterProvider } from "react-router-dom"
import { Provider } from "react-redux"
import { PersistGate } from "redux-persist/integration/react"
import { Box, CssBaseline, ThemeProvider, createTheme } from "@mui/material"
import { ToastContainer } from "react-toastify"
import { persistor, store } from "./app/store"
import { router } from "./app/router"
import "react-toastify/dist/ReactToastify.css"
import "./index.css"

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#ab211c",
    },
  },
})

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <RouterProvider router={router}>
            <PersistGate loading={null} persistor={persistor}>
              <CssBaseline />
              <Box display="flex" flexDirection="column" minHeight="100vh">
                <Outlet />
              </Box>
            </PersistGate>
          </RouterProvider>
        </Provider>
      </ThemeProvider>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  )
}

export default App
